import * as React from 'react';

import classnames from 'classnames';

import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import {RemoveButton} from '../button/remove-button/remove-button';
import {colors} from '../colors/colors';
import type {ColorName} from '../colors/colors';

import styles from './entity-pill.module.css';

const STYLED_PILL_TYPES = [
    'leads',
    'users',
    'teams',
    'contacts',
    'accounts',
    // straight color overrides
    'dark',
    'light',
    'colorName',
    'leftBorder',
];

type Props = {
    name?: string | React.ReactNode;
    sublabel?: string | React.ReactNode;
    type: string;
    htmlUrl?: string;
    isLinkable?: boolean;
    onRemove?: () => any;
    isSmall?: boolean;
    removeButtonTooltip?: string;
    colorName?: ColorName;
    tooltipText?: string | null | undefined;
};

export function EntityPill(props: Props) {
    const {type = 'default', isLinkable = true} = props;

    const entityName =
        props.name &&
        ((typeof props.name === 'string' && props.name.length) ||
            // typeof on React.Node returns an object :(
            typeof props.name === 'object') ? (
            <span>{props.name}</span>
        ) : (
            <span className={styles.nameless}>Unnamed {getSingularEntityType(type)}</span>
        );

    const clickNavigatesToEntity = isLinkable && props.htmlUrl;

    const classes = classnames(styles.container, {
        // @ts-expect-error
        [styles[`container-${type}`]]: STYLED_PILL_TYPES.includes(type),
        [styles['container-small']]: props.isSmall,
        [styles['container-default']]: !STYLED_PILL_TYPES.includes(type),
        [styles['container-unclickable']]: !props.onRemove && !clickNavigatesToEntity,
        [styles['container-linkable']]: clickNavigatesToEntity,
    });

    const localStyles = {
        ...(props.colorName && type !== 'leftBorder'
            ? {backgroundColor: colors[props.colorName]}
            : {}),
        ...(props.colorName && type === 'leftBorder'
            ? {borderLeft: `4px solid ${colors[props.colorName]}`}
            : {}),
    } as const;

    const handleRemove = (e: React.SyntheticEvent<any>) => {
        e.stopPropagation();

        if (props.onRemove) {
            props.onRemove();
        }
    };

    return (
        <div style={localStyles} data-tip={props.tooltipText} className={classes}>
            {clickNavigatesToEntity ? (
                <a
                    onMouseDown={(e) => e.stopPropagation()}
                    href={props.htmlUrl}
                    className={styles['entity-container']}
                >
                    {entityName}
                    <div className={styles.sublabel}>{props.sublabel}</div>
                </a>
            ) : (
                <span className={styles['entity-container']}>
                    {entityName}
                    <div className={styles.sublabel}>{props.sublabel}</div>
                </span>
            )}
            {props.onRemove && (
                <RemoveButton
                    onClick={handleRemove}
                    size={props.isSmall ? 7 : 9}
                    tooltip={props.removeButtonTooltip}
                />
            )}
        </div>
    );
}
